







































import { Prop, Component, Vue, Inject } from "vue-property-decorator";
import AbcButton from "../../components/button/AbcButton.vue";
import AbcToolButton from "../../components/button/AbcToolButton.vue";

@Component({
    components: {
        AbcButton,
        AbcToolButton,
    },
})
export default class AbcFormButtons extends Vue {
    @Prop() disableConfirmButton!: boolean;
    @Prop() disableSaveButton!: boolean;
    @Prop({ type: Boolean }) hasContinue!: boolean;
    @Prop({ type: Boolean }) isCondensed!: boolean;
}
